module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_studioemu-c1c5eaad1b193c96528e76531bf8dc46.svg";